import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'FEEDBACK_MOTORISTA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('feedbackMotoristaForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/feedbackMotorista`);
    return {
        type: 'FEEDBACK_MOTORISTA_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/feedbackMotorista`, {
				...registro,
				data_feedback: DateFormat.formatarDataTelaParaSql(registro.data_feedback),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/feedbackMotorista`, {
				...registro,
				data_feedback: DateFormat.formatarDataTelaParaSql(registro.data_feedback),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/feedbackMotorista?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/feedbackMotoristaTipo/listarSelect`);
    return {
        type: 'FEEDBACK_MOTORISTA_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaGrupo() {
    const request = axios.get(`${consts.API_URL}/feedbackMotoristaGrupo/listarSelect`);
    return {
        type: 'FEEDBACK_MOTORISTA_GRUPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'FEEDBACK_MOTORISTA_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'FEEDBACK_MOTORISTA_VEICULO_SELECT_LISTADO',
        payload: request
    };
}